import { ScrollArea, Text } from "@radix-ui/themes";
import { ReactNode } from "react";

export const AnnotationFormWrapper: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  return (
    <>
      <Text size="2" weight="bold" m="2" as="p">
        Event annotation
      </Text>
      <ScrollArea className="px-2 h-[calc(100%-42px)]">{children}</ScrollArea>
    </>
  );
};
